/* eslint-disable */
import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import Tab from '../../component/Inc/Tab';
function PopFinishClassPlan(props) {
  const {open, close} = props;
  const [detailTabIdx, setDetailTabIdx] = useState(0);
  const detailTab = [
    {title: '마무리 수업 계획서', value: 0},
    {title: '마무리 담임 보고서', value: 1}
  ];
  return (
    <Modal open={open} close={close} type="com_input pop_finish_class_plan">
      <Tab data={detailTab} tab={detailTabIdx} setTab={setDetailTabIdx} />
      <div className="content_container scroll">
        <div className="com_info">
          <p className="name">김교사104</p>
          <span className="dot" />
          <p className="date">2023.05.20 11:30</p>
        </div>
        {detailTabIdx === 0 ? (
          <div className="tab_content">
            <section className="com_board_search">
              <select className="select">
                <option value="수업 선택">수업 선택</option>
              </select>
              <article className="search">
                <input type="search" placeholder="학생 검색" className="input xs type_search" />
                <button className="com_btn gray ws xs icon_search"></button>
              </article>
            </section>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    (고3ㆍ경기고등학교ㆍ본사)
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info type_row">
                  <span className="tit">과목</span>
                  <div className="cont">
                    <p className="txt">국어 | 2T</p>
                  </div>
                  <span className="tit">수업진행</span>
                  <div className="cont">
                    <p className="txt">10/35 회차 진행중</p>
                  </div>
                </div>
                <div className="info type_row">
                  <span className="tit">과목</span>
                  <div className="cont">
                    <p className="txt com_blue_txt">국어</p>
                  </div>
                  <span className="tit">담임</span>
                  <div className="cont">
                    <p className="txt com_blue_txt">김담임898</p>
                  </div>
                </div>
              </div>
              <div className="detail_tit dot">수업추가 계약 내용 입력</div>
              <div className="board_item">
                <div className="">
                  <div className="com_input_wrap flex_between">
                    <span className="txt">기준일 입력</span>
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                    <span className="txt">수업 추가 선택</span>
                    <select className="select">
                      <option value="타임 추가">타임 추가</option>
                    </select>
                  </div>
                  <hr className="com_divider" />
                  <div className="com_input_wrap flex_between">
                    <input type="text" className="input xs com_blue_txt" defaultValue={`34`} />
                    <span className="txt">회 이후</span>
                    <input type="text" className="input xs com_blue_txt" defaultValue={`11`} />
                    <span className="txt">더 진행하여</span>
                    <input type="text" className="input xs com_blue_txt" defaultValue={`45`} />
                    <span className="txt">회로 종료</span>
                  </div>
                  <hr className="com_divider" />
                  <span className="cont">
                    추가 입금 예정액 :{' '}
                    <span className="bold">
                      150,000 X 11 = <span className="com_blue_txt">1650,00</span>
                    </span>
                  </span>
                </div>
              </div>

              <div className="detail_tit dot">응원 한마디 (선택입력)</div>
              <select name="" id="" className="select">
                <option value="너무 잘 하고 있어! 이대로 인서울 고고!!">너무 잘 하고 있어! 이대로 인서울 고고!!</option>
              </select>
            </div>
            <div className="btn_container">
              <button className="com_btn orange xs">등록</button>
            </div>
          </div>
        ) : (
          <div className="tab_content">
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    (고3ㆍ경기고등학교ㆍ본사)
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info type_row">
                  <span className="tit">과목</span>
                  <div className="cont">
                    <p className="txt">국어 | 2T</p>
                  </div>
                  <span className="tit">수업진행</span>
                  <div className="cont">
                    <p className="txt">10/35 회차 진행중</p>
                  </div>
                </div>
                <div className="info type_row">
                  <span className="tit">과목</span>
                  <div className="cont">
                    <p className="txt">국어</p>
                  </div>
                  <span className="tit">담임</span>
                  <div className="cont">
                    <p className="txt">김담임898</p>
                  </div>
                </div>
              </div>
              <div className="board_item">
                <div className="">
                  <div className="com_input_wrap">
                    <span className="txt">
                      기준일 : <span className="bold">2023. 04. 10</span>
                    </span>
                    <span className="txt">
                      수업 추가 : <span className="bold">타임추가</span>
                    </span>
                  </div>
                  <hr className="com_divider" />
                  <div className="com_input_wrap flex_between">
                    <input type="text" className="input xs com_blue_txt" defaultValue={`34`} />
                    <span className="txt">회 이후</span>
                    <input type="text" className="input xs com_blue_txt" defaultValue={`11`} />
                    <span className="txt">더 진행하여</span>
                    <input type="text" className="input xs com_blue_txt" defaultValue={`45`} />
                    <span className="txt">회로 종료</span>
                  </div>
                  <hr className="com_divider" />
                  <span className="cont">
                    추가 입금 예정액 : <span className="bold">150,000 X 11 = 1650,00</span>
                  </span>
                </div>
              </div>
              <div className="detail_tit dot">최종 수업추가 계약 내용 입력</div>
              <div className="board_item">
                <div className="">
                  <div className="com_input_wrap">
                    <span className="txt">수업 추가 선택</span>
                    <select className="select">
                      <option value="타임 추가">타임 추가</option>
                    </select>
                  </div>
                  <hr className="com_divider" />
                  <div className="com_input_wrap flex_between">
                    <input type="text" className="input xs com_blue_txt" defaultValue={`34`} />
                    <span className="txt">회 이후</span>
                    <input type="text" className="input xs com_blue_txt" defaultValue={`11`} />
                    <span className="txt">더 진행하여</span>
                    <input type="text" className="input xs com_blue_txt" defaultValue={`45`} />
                    <span className="txt">회로 종료</span>
                  </div>
                  <hr className="com_divider" />
                  <span className="cont">
                    추가 입금 예정액 :{' '}
                    <span className="bold">
                      150,000 X 11 = <span className="com_blue_txt">1650,00</span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className="comment_wrap">
              <textarea className="textarea" placeholder="내용입력"></textarea>
            </div>
            <div className="detail_tit dot">입금 여부</div>
            <div className="com_board_box">
              <div className="board_item type_input">
                <div className="info">
                  <span className="tit">입금 방법 선택</span>
                  <div className="cont">
                    <select className="select">
                      <option value="현금">현금</option>
                    </select>
                  </div>
                </div>
                <div className="info">
                  <span className="tit">입금자 명</span>
                  <div className="cont">
                    <input type="text" className="input" placeholder="임금자명 입력" />
                  </div>
                </div>
                <div className="info">
                  <span className="tit">입금일</span>
                  <div className="cont">
                    <input type="date" className="com_datepicker" placeholder="입금일 선택" />
                  </div>
                </div>
                <div className="info">
                  <span className="tit">계좌번호</span>
                  <div className="cont">
                    <input type="text" className="input" placeholder="하나은행) 1234-39390000090" />
                  </div>
                </div>
                <div className="info">
                  <span className="tit">입금액</span>
                  <div className="cont">
                    <input type="text" className="input com_blue_txt" defaultValue={`450,000원`} />
                  </div>
                </div>
              </div>
            </div>

            <div className="btn_container">
              <button className="com_btn gray xs">취소</button>
              <button className="com_btn orange xs">등록</button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default PopFinishClassPlan;
